import type { FC } from "react";

import type { UseFormReturn } from "react-hook-form";

import type { InvestmentTimeHorizon } from "~/v2/api/rest/account";
import { RadiosInput } from "../../RadiosInput";
import type { InvestmentExperience } from "./schema";

const LABEL =
  "What is the expected period of time you plan to invest to achieve your financial goal(s)?";

const OPTIONS: {
  label: string;
  value: InvestmentTimeHorizon;
}[] = [
  { label: "Under 1 year", value: "less_than_1_year" },
  { label: "1 - 2 years", value: "1_to_2_years" },
  { label: "3 - 5 years", value: "3_to_5_years" },
  { label: "6 - 10 years", value: "6_to_10_years" },
  { label: "Over 10 years", value: "more_than_10_years" },
];

type TimePeriodInputProps = {
  form: UseFormReturn<InvestmentExperience>;
};

export const TimeHorizonInput: FC<TimePeriodInputProps> = ({ form }) => {
  const {
    setValue,
    watch,
    formState: { errors },
  } = form;

  const timePeriod = watch("investment_time_horizon");
  const errorMessage = errors.investment_time_horizon?.message;

  const onSelect = (value: string) =>
    setValue("investment_time_horizon", value as InvestmentTimeHorizon);

  return (
    <RadiosInput
      id="investment_time_horizon"
      label={LABEL}
      value={timePeriod}
      options={OPTIONS}
      onSelect={onSelect}
      errorMessage={errorMessage}
    />
  );
};
